type StoredAuth = {
  accessToken: string;
  refreshToken: string;
  email: string;
};

const KEY = 'wa.auth.tokens';

function read(): StoredAuth | null {
  const raw = localStorage.getItem(KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as StoredAuth;
  } catch {
    // Corrupt JSON — clear and treat as empty.
    localStorage.removeItem(KEY);
    return null;
  }
}

export const tokenStorage = {
  getAll(): StoredAuth | null {
    return read();
  },
  setAll(stored: StoredAuth): void {
    localStorage.setItem(KEY, JSON.stringify(stored));
  },
  clearAll(): void {
    localStorage.removeItem(KEY);
  },
  getAccessToken(): string | null {
    return read()?.accessToken ?? null;
  },
  getRefreshToken(): string | null {
    return read()?.refreshToken ?? null;
  },
  getEmail(): string | null {
    return read()?.email ?? null;
  },
  updateAccessToken(accessToken: string): void {
    const current = read();
    if (!current) return;
    localStorage.setItem(KEY, JSON.stringify({ ...current, accessToken }));
  },
};

export type { StoredAuth };
